export const endpointToJsonAPI = (endpoint) => {
  const processed = {
    id: endpoint.id,
    name: endpoint.name,
    origin_url: endpoint.originURL,
    ip_whitelist: [],
  };
  for (let i = 0; i < endpoint.ipWhitelist.length; i += 1) {
    const subnet = endpoint.ipWhitelist[i].ip;
    if (subnet) {
      processed.ip_whitelist.push(subnet);
    }
  }
  return processed;
};

export const JsonAPIEndpointToNorm = (endpoint) => {
  const processed = {
    id: endpoint.id,
    name: endpoint.name,
    created: endpoint.created,
    updated: endpoint.updated,
    url: endpoint.url,
    originURL: endpoint.origin_url,
    state: endpoint.state,
    error: endpoint.error,
    ipWhitelist: [],
    disabled: endpoint.disabled || false,
  };
  for (let i = 0; i < endpoint.ip_whitelist.length; i += 1) {
    const subnet = endpoint.ip_whitelist[i];
    processed.ipWhitelist.push({ ip: subnet });
  }
  return processed;
};
